import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

import Column from "../../../common/components/Column"
import RecruitProfileDisplayFieldGrid from "../settings/RecruitProfileDisplayFieldGrid"
import RecruitProfileNestedPanel from "../settings/RecruitProfileNestedPanel"
import {
  getBoostCampaignDisplayGroups,
  normalizeBoostCampaignCriteria,
} from "./boostCampaignCriteria"

const CHIP_LABELS = [
  "Brands to exclude",
  "Offices to exclude",
  "People to exclude",
  "Cities to exclude",
  "Counties to exclude",
  "Additional note",
  "Target Cities",
  "Target States",
  "Target Counties",
]

/**
 * Read-only summary of saved Lead Targeting for Campaign criteria.
 *
 * @param {object} props
 * @param {object} props.criteria
 * @param {string} [props.mlsFallback] Selected MLS name(s) from CRM when not on saved criteria.
 */
export default function MyMlsBoostCampaignSummary({
  criteria,
  mlsFallback = "",
}) {
  const normalized = normalizeBoostCampaignCriteria(criteria)
  const groups = getBoostCampaignDisplayGroups(criteria, {
    showAllFields: true,
    mlsFallback,
  })

  if (groups.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No targeting criteria saved yet. On <strong>My Leads</strong>, use{" "}
        <strong>Lead Targeting for Campaign</strong> to set target type, MLS,
        cities, states, radius, brands, and sales filters.
      </Typography>
    )
  }

  return (
    <Column sx={{ gap: 1.5, alignItems: "stretch" }}>
      {groups.map((group) => (
        <RecruitProfileNestedPanel key={group.title} title={group.title}>
          <RecruitProfileDisplayFieldGrid
            rows={group.rows}
            chipLabels={CHIP_LABELS}
            fullWidthLabels={[
              "Brands to exclude",
              "Offices to exclude",
              "People to exclude",
              "Additional note",
              "Upload media set",
            ]}
          />
          {group.title === "Additional info" &&
          normalized.additionalMediaUrl?.trim() ? (
            <Box
              component="img"
              src={normalized.additionalMediaUrl}
              alt="Lead targeting reference media"
              sx={{
                mt: 1,
                display: "block",
                maxWidth: "100%",
                maxHeight: 220,
                borderRadius: 1,
                border: "1px solid",
                borderColor: "divider",
              }}
            />
          ) : null}
        </RecruitProfileNestedPanel>
      ))}
    </Column>
  )
}
